'use client';

import { signOut } from 'src/app/api/auth/auth-client';
import { useClearSession } from 'src/services/state/providers/SessionProvider';

export function useSignOutOnClick(): () => Promise<void> {
  const clearSession = useClearSession();

  return async () => {
    await signOut();
    // clearSession() sets isClearing: true in SessionProvider, which RedirectGuard
    // reads to permanently suppress the OAuth redirect for this page lifecycle.
    clearSession();
    // eslint-disable-next-line @next/next/no-location-assign-relative-destination
    window.location.assign(`${process.env.NEXT_PUBLIC_BASE_PATH}/login`);
  };
}
